export default __webpack_public_path__ + "static/media/EcoBadgeMobile.0c11aca7.svg";